/**
 * "View as": an office user looking at the contractor portal as one contractor, read-only.
 * The target lives in sessionStorage, so it belongs to this tab alone and closing the tab
 * ends it; two tabs can look at two different contractors.
 */
const KEY = 'teknika_view_as';

/** Only these calls carry the header; the server ignores it anywhere else. */
export const VIEW_AS_PATH = /^\/api\/(portal\/|auth\/portal\/me(\?|$))/;

/** The portal user this tab is viewing as, or null. */
export function viewAsId(): number | null {
  try {
    const n = Number(sessionStorage.getItem(KEY));
    return Number.isSafeInteger(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

/** Once, at start-up: take `?as=<id>` from the address into this tab, then remove it from the address. */
export function captureViewAs(): void {
  try {
    const url = new URL(window.location.href);
    const as = url.searchParams.get('as');
    if (as === null) return;
    const n = Number(as);
    if (as !== '' && Number.isSafeInteger(n) && n > 0) sessionStorage.setItem(KEY, String(n));
    url.searchParams.delete('as');
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
  } catch {
    // Storage blocked: the portal simply opens as an ordinary sign-in.
  }
}

export function leaveViewAs(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
